<mat-form-field style="width: 100%;">
    <mat-label>Note</mat-label>
    <textarea style="min-height: 100px;" matInput [value]="note" mat-autoresize="true" placeholder="Note concernant le patient"></textarea>
</mat-form-field>
  